if (!customElements.get('sk-country-picker')) {
  customElements.define('sk-country-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.bindGlobalListeners();
        return;
      }
      this.ready = true;
      this.toggle = this.querySelector('.sk-country-toggle');
      this.panel = this.querySelector('.sk-country-panel');
      const search = this.querySelector('.sk-country-search');
      const options = [...this.querySelectorAll('.sk-country-option')];
      const empty = this.querySelector('.sk-country-empty');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        event.stopPropagation();
        if (button !== this.toggle) return;
        if (!this.panel.hidden) {
          this.close();
          return;
        }
        document.querySelectorAll('sk-country-picker').forEach(picker => {
          if (picker !== this) picker.close?.();
        });
        this.positionPanel();
        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
      }, true);
      search.addEventListener('input', () => {
        const query = normalize(search.value);
        options.forEach(option => {
          option.hidden = !normalize(option.textContent + ' ' + option.value).includes(query);
        });
        empty.hidden = options.some(option => !option.hidden);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.panel.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
        this.toggle.focus();
      }, true);
      this.outside = event => {
        if (!this.contains(event.target)) this.close();
      };
      this.reposition = () => {
        if (!this.panel.hidden) this.positionPanel();
      };
      this.bindGlobalListeners();
    }
    bindGlobalListeners() {
      document.addEventListener('click', this.outside, true);
      window.addEventListener('resize', this.reposition, { passive: true });
      window.addEventListener('scroll', this.reposition, { passive: true });
    }
    positionPanel() {
      if (!this.closest('.sk-header-locale')) return;
      const header = this.closest('header.header');
      const bottom = (header || this.toggle).getBoundingClientRect().bottom;
      this.panel.style.setProperty('--sk-picker-top', Math.max(8, bottom + 6) + 'px');
    }
    close() {
      if (!this.panel || !this.toggle) return;
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.outside, true);
      window.removeEventListener('resize', this.reposition);
      window.removeEventListener('scroll', this.reposition);
    }
  });
}
